import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import admin from './modules/admin';
import field from './modules/field';
import survey from './modules/survey';
import user from './modules/user';

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.API_HOST;

Vue.axios.interceptors.request.use((request) => {
  const url = request.url.replace(`${request.baseURL}/`, '');
  if (user.state.sessionId && (url !== 'auth' || (url === 'auth' && request.method === 'delete'))) {
    request.headers = { Authorization: user.state.sessionId };
  }
  return request;
});

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    admin,
    field,
    survey,
    user,
  },
  strict: debug,
});
